import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merge Tailwind classNames with conflict resolution.
 * `clsx` resolves conditionals/arrays/objects; `twMerge` dedupes conflicting
 * Tailwind utilities (e.g. `px-2 px-4` → `px-4`). Use this in every primitive
 * instead of raw clsx so caller `className` overrides win predictably.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
